import i18n from "@/i18n";
import moment from "moment";

export function syncLocaleFromAccount(countryCode: string): void {
  const locale = (countryCode?.toLowerCase() || "id").replace(/\s/g, "");
  const norm = locale.replace(/_/g, "-");
  const isMalaysia = norm.startsWith("my") || norm.startsWith("ms");
  const localeValue = isMalaysia ? "my" : norm.startsWith("id") ? "id" : norm.startsWith("en") ? "en" : norm;
  if (
    i18n.global.locale &&
    typeof (i18n.global.locale as any).value !== "undefined"
  ) {
    (i18n.global.locale as any).value = localeValue;
  } else {
    (i18n.global as any).locale = localeValue;
  }
  if (locale !== "id") {
    moment.locale("en");
  }
}
